
import React from 'react';
import { CircleDecoration } from '../Animations';
import OptimizedFadeIn from '../OptimizedFadeIn';
import CTAButton from './CTAButton';
import { useWaitlist } from '../../context/WaitlistContext';

interface CTASectionProps {
  isAuthenticated: boolean;
}

const CTASection: React.FC<CTASectionProps> = ({ isAuthenticated }) => {
  const { scrollToWaitlist } = useWaitlist();

  return (
    <section className="bg-[#E27D60] text-white py-16 relative">
      <CircleDecoration 
        size={200} 
        color="rgba(255, 255, 255, 0.1)" 
        className="absolute top-10 right-10 z-0" 
      />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <OptimizedFadeIn>
            <h2 className="text-3xl sm:text-4xl font-display font-semibold mb-6">
              Ready to Begin Your Hormonal Harmony Journey?
            </h2>
          </OptimizedFadeIn>
          
          <OptimizedFadeIn>
            <p className="text-white/80 text-lg mb-8">
              Our exclusive 30-day program has limited spots available. 
              {isAuthenticated ? " Continue your journey today!" : " Join our waitlist or log in with your invite."}
            </p>
          </OptimizedFadeIn>
          
          <OptimizedFadeIn>
            {isAuthenticated ? (
              <CTAButton to="/integrated-dashboard" variant="white">
                Continue Your Journey
              </CTAButton>
            ) : (
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <CTAButton to="/login" variant="white" className="w-full sm:w-auto">
                  Log In With Invite
                </CTAButton>
                
                <CTAButton 
                  onClick={scrollToWaitlist}
                  variant="default"
                  className="bg-black/70 hover:bg-black text-white w-full sm:w-auto"
                >
                  Join the Waitlist
                </CTAButton>
              </div>
            )}
          </OptimizedFadeIn>
        </div>
      </div>
    </section>
  );
};

export default React.memo(CTASection);
